
<app-modal-header [title]="title" (closeModal)="closeModal()"></app-modal-header>

<!-- Displaying Loading Indicator -->
<div *ngIf="loading" class="loading-indicator">
  Loading data, please wait...
</div>

<!-- Displaying Table When Data is Loaded -->
<app-paginated-data-table
  *ngIf="!loading"
  [tableList]="tableData"
  [resetTable]="refreshDataTable"
  [tableConfigurations]="tableConfiguration">
</app-paginated-data-table>



<!-- Handling Error Message -->
<div *ngIf="!loading && tableConfiguration.empty_msg" class="error-message">
  {{ tableConfiguration.empty_msg }}
</div>
